import React, { useState, useEffect } from 'react'
import Header from '@insight/toolkit-react/lib/Header/Header'
import { isMobile, throttle } from '@insight/toolkit-utils';

import Cart from '../IAHeaderTop/Cart'
import AccountMenuButton from './AccountMenuButton'
import { ENABLE_NIA } from '../../api/common/constants'

export default function MobileNav({ showOnlyCart = false, setIsOpen, featureFlags }) {
  const [isOnMobile, setIsMobile] = useState(isMobile())

  useEffect(() => {
    const onResize = throttle(() => {
      setIsMobile(isMobile())
    }, 250)
    window.addEventListener('resize', onResize)
    return () => {
      window.removeEventListener('resize', onResize)
    }
  }, [])

  const handleClick = () => {
    setIsOpen(true)
  }
  const enable_NIA = featureFlags && featureFlags[ENABLE_NIA]

  return (
    <Header.Nav.Mobile>
      {enable_NIA && !isOnMobile && (<Header.Nav.Mobile.Item
        icon="NIA"
        target={'_blank'}
        onClick={handleClick}
        className="c-header-main-nav__mobile-nia"
        newIcon={true}
      >
        Nia
      </Header.Nav.Mobile.Item>)}
      {enable_NIA && isOnMobile && (<Header.Nav.Mobile.Item
        icon="NIA-mobile"
        target={'_blank'}
        onClick={handleClick}
        className="c-header-main-nav__mobile-nia"
      >
      </Header.Nav.Mobile.Item>)}
      {!showOnlyCart ? <AccountMenuButton />:null}
      <Cart isMobile />
      {!showOnlyCart ? <Header.Nav.Mobile.Search />:null}
      <Header.Nav.Mobile.Hamburger activates="flyout1" />
    </Header.Nav.Mobile>
  )
}

MobileNav.propTypes = {}
